module.exports = __webpack_public_path__ + "assets/images/skincolor-01.c2cb84b7c8a42c786e570e6f166b3eff.svg";